const commitCompanyData = (commit, dataForStore) => {
  commit('LOAD_COMMODITY_ITEMS', dataForStore['commodities'], { root: true })
  commit('LOAD_CUSTOM_RATE_ITEMS', dataForStore['customRates'], { root: true })
  commit('LOAD_SEED_ITEMS', dataForStore['seeds'], { root: true })
  commit('LOAD_IRRIGATION_ITEMS', dataForStore['irrigation'], { root: true })
  commit('LOAD_OTHER_INCOME_ITEMS', dataForStore['otherIncomes'], { root: true })
  commit('LOAD_OTHER_EXPENSE_ITEMS', dataForStore['otherExpenses'], { root: true })
  commit('LOAD_CONVERT_UNIT_ITEMS', dataForStore['convertUnits'], { root: true })
  commit('LOAD_CHEMICAL_ITEMS', dataForStore['chemicals'], { root: true })
  commit('LOAD_FERTILIZER_ITEMS', dataForStore['fertilizers'], { root: true })
  commit('LOAD_CROP_ITEMS', dataForStore['crops'], { root: true })
  commit('LOAD_CROP_FERTILIZER_DETAIL_ITEMS', dataForStore['cropsFertilizers'], { root: true })
  commit('LOAD_CROP_CHEMICAL_DETAIL_ITEMS', dataForStore['cropsChemicals'], { root: true })
  commit('LOAD_CROP_CUSTOM_RATE_DETAIL_ITEMS', dataForStore['cropsCustomRates'], { root: true })
  commit('LOAD_CROP_SEED_DETAIL_ITEMS', dataForStore['cropsSeeds'], { root: true })
  commit('LOAD_CROP_IRRIGATION_DETAIL_ITEMS', dataForStore['cropsIrrigations'], { root: true })
  commit('LOAD_CROP_COMMODITY_DETAIL_ITEMS', dataForStore['cropsCommodities'], { root: true })
  commit('LOAD_CROP_OTHER_INCOME_DETAIL_ITEMS', dataForStore['cropsOtherIncomes'], { root: true })
  commit('LOAD_CROP_OTHER_EXPENSE_DETAIL_ITEMS', dataForStore['cropsOtherExpenses'], { root: true })
}

const state = {}

const mutations = {}

const actions = {
  loadCompanyData ({ commit }, dataForStore) {
    commitCompanyData(commit, dataForStore)
  }
}

const getters = {}

const companyModule = {
  state,
  mutations,
  actions,
  getters
}

export default companyModule
